<template>
  <div>
    <div width="100%" style="background-color: #CCC; border-radius: 3px; padding-left: 10px; border: 1px solid;">
      <span class="font-weight-bold text-uppercase h-4">{{ aItems[nIndex].Pregunta }}</span>
    </div>
    <div v-for="oDataProcess in aDataProcess" :key="oDataProcess.IdRespuesta" width="100%" style="border: 1px solid; border-radius:3px; padding-left: 10px;">
      <span v-html="oDataProcess.Respuesta"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    aItems: Array,
    nIndex: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.proccessData()
  },
  data () {
    return {
      aDataProcess: []
    }
  },
  methods: {
    proccessData () {
      if (("Detalle" in this.aItems[this.nIndex])) {
        const Details = JSON.parse(this.aItems[this.nIndex].Detalle.toString().trim().replace(/(\r\n|\n|\r)/gm, ""))
        this.aDataProcess = Details
      }
    }
  }
}
</script>
